export class SpedStudentCollectionCard {
  CollectionId: number;
  CollectionName: string;
  CollectionCode: string;
  CollectionVisible: boolean;
}


export class CaseManagementHistory {
  Id: number;
  CaseManagerId: number;
  SiteId: number;
  SiteDescription: string;
  CaseManagerDisplayName: string;
  SchoolIdentifierCIS: string;
  AssignedDate: Date;
  EndDate: Date;
  Note: string;
  StudentId: number;

  // non Dto
  Reason: string;

}
export class SpEdSite {
  SiteId: number;
  SiteCode: string;
  SiteName: string;

}
export class CaseManager {
  SiteId: number;
  CaseManagerId: number;
  SiteDescription: string;
  CaseManagerDisplayName: string;
  SiteDescription1: string;
}
export class ImportedDocuments {
  SpedDocumentId: number;
  Description: string;
  DocumentName: string;
  CreatedDate: Date;
  UserName: string;
  SpEdDocumentToStudentInstanceId: number;
  FileBase64: string;
  // non dto Fields
  MyFileBase64String: string;
  FileType: string;
  FileName: string;
  StudentId: number;
  FileExtension: string;
  spedCollectionToStudentId: number;
}

export class SpedCollectionStudentToTeamMember {
  TeamMemberId: number;
  TeamMemberName: string;
  IsCreator: boolean;

  // Non DTO Field
  SelectTeamMember: boolean;
}

export class SpecialServicesSummary {
  SpecialEducation: string;
  CaseManager: String;
}

export class SpEdSummaryCodes {
  Code: string;
  Description: String;
}

export class AssessmentsReport {
  ReportId: number;
  StudentId: number;
  BatteryId: number;
  SpedLookUpDataId: number;
  Type: string;
  Attachment: boolean;
  CreatedBy: string;
  ReportStartDate: Date;
  ReportEndDate: Date;
  TemplateName: string;
  Status: string;
}